type Props = {
  /** ラベルの名前。*/
  labelName: string;
  /** プレースホルダー。*/
  placeholder: string;
  /** インプットフィールドのID。*/
  inputId: string;
  /** インプットフィールドのタイプ。デフォルトは 'text'。*/
  type?: 'text' | 'password';
  /** インプットフィールドの値。*/
  value: string;
  /** インプットフィールドの値を変更する関数。*/
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

/** InputFieldのコンポーネント。 */
export const InputField = ({
  labelName,
  placeholder,
  inputId,
  type = 'text',
  value,
  onChange: handleChange,
}: Props) => {
  return (
    <div className="relative">
      <label
        htmlFor={inputId}
        className="absolute -top-2 left-3 bg-surface px-2 text-textPrimary text-[12px] noto-sans-jp-regular"
      >
        {labelName}
      </label>
      <input
        id={inputId}
        type={type}
        placeholder={placeholder}
        className="w-full border border-textPrimary rounded-[4px] p-[16px] text-textPrimary placeholder:text-textSecondary noto-sans-jp-regular focus:outline-none"
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};
